import axios from "axios";

import { IGasPriceResponse } from "../interfaces/common";
import { cryptoCompareAPI } from "../keys/cryptoCompareAPI";

/**
 * Fetch gas price from etherscan
 */
const getGasPrice = async (): Promise<IGasPriceResponse | null> => {
  try {
    const url =
      "https://api.etherscan.io/api?module=gastracker&action=gasoracle&apikey=V7AV9QARVUP79WH3B5CP5VMWXCIC72DA4Q";
    const { data } = await axios.get(url);
    return data;
  } catch (err) {
    console.warn(err);
    return null;
  }
};

/**
 * Get bsc price
 */
const getBSCGasPrice = async (): Promise<any | null> => {
  try {
    const url =
      "https://bscgas.info/gas?apikey=94b89280aab34818acebada10f409e9f";
    const { data } = await axios.get(url);

    return {
      LastBlock: data.last_block,
      SafeGasPrice: data.fast,
      ProposeGasPrice: data.fast,
      FastGasPrice: data.instant,
    };
  } catch (err) {
    console.warn(err);
    return null;
  }
};

/**
 * Fetch coin data
 */
const fetchCoinData = async (
  network: string,
  Address: string | null,
  abortController: AbortController
) => {
  try {
    if (!Address || network === "heco") {
      return null;
    }
    const url = `https://api.coingecko.com/api/v3/coins/${network}/contract/${Address}`;
    const { data } = await axios.get(url, {
      signal: abortController.signal,
      timeout: 10000,
    });
    return data;
  } catch (err) {
    console.warn(err);
    return null;
  }
};

const getTokensPrice = (fsyms: string) => axios.get(
  `https://min-api.cryptocompare.com/data/pricemultifull?fsyms=${fsyms}&tsyms=USDT`,
  {
    headers: { Authorization: `Apikey ${cryptoCompareAPI}` }
  });

export {
  getGasPrice,
  getBSCGasPrice,
  fetchCoinData,
  getTokensPrice,
};
